// The document language (<html lang>, WCAG 3.1.1). The app sets it to the
// catalog it renders and remembers it on this device, so ui/boot.ts can set
// the same value before the first paint instead of a hard-coded one. Without a
// remembered value the browser language decides, as it does for the app.
import { EU_APP_LOCALES, localeLanguage, resolveRequestedAppLocale } from '@/i18n/eu-locales';

export const LANG_KEY = 'poneva.lang';
const CATALOG_LANGUAGES = new Set<string>(EU_APP_LOCALES.map((locale) => localeLanguage(locale)));

/** The catalog language for a locale: its language when the app has that catalog, else English. */
export function catalogLanguage(locale: string | null | undefined): string {
  const language = localeLanguage(locale);
  return CATALOG_LANGUAGES.has(language) ? language : 'en';
}

/** The language this device last showed, else the browser's. */
export function bootLanguage(browserLocale: string | null | undefined): string {
  try {
    const stored = localStorage.getItem(LANG_KEY);
    if (stored && CATALOG_LANGUAGES.has(stored)) return stored;
  } catch {
    /* private mode / storage disabled — use the browser language */
  }
  return catalogLanguage(resolveRequestedAppLocale(null, browserLocale));
}

/** Show a catalog language on the document and remember it for the next first paint. */
export function showDocumentLanguage(language: string) {
  document.documentElement.lang = language;
  try {
    localStorage.setItem(LANG_KEY, language);
  } catch {
    /* best effort */
  }
}
